/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './DriverInformation.module.scss'
import { dateOfBirthAction, masterNumberDOBAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const DateOfBirth = ({
  t,
  validateDateOfBirth,
  validateMasterNumber,
  dateOfBirthError,
  dateOfBirthValid,
  dateOfBirthDayEl,
  dateOfBirthMonthEl,
  dateOfBirthYearEl,
  setIsError,
}) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const dateOfBirth = useSelector((state) => state.driver.driverInformation.dateOfBirth)
  const masterNumber = useSelector((state) => state.driver.driverInformation.masterNumber)

  const handleDateOfBirthDay = (e) => {
    try {
      const regex = RegExp(/^\d+$/)
      if (regex.test(dateOfBirthDayEl.current.value)) {
        let value = dateOfBirthDayEl.current.value
        if (value !== '' && parseInt(value) > 0 && parseInt(value) < 10) {
          value = '0' + value.toString()
        } else {
          value = value.substr(1)
        }
        dispatch(dateOfBirthAction(`${dateOfBirthYearEl.current.value}-${dateOfBirthMonthEl.current.value}-${value}`))
        dispatch(masterNumberDOBAction(`${value}${dateOfBirthMonthEl.current.value}${dateOfBirthYearEl.current.value.substring(2)}`))
        validateDateOfBirth()
      }
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const handleDateOfBirthMonth = (e) => {
    try {
      const regex = RegExp(/^\d+$/)
      if (regex.test(dateOfBirthMonthEl.current.value)) {
        let value = dateOfBirthMonthEl.current.value
        if (value !== '' && parseInt(value) > 0 && parseInt(value) < 10) {
          value = '0' + value.toString()
        } else {
          value = value.substr(1)
        }
        dispatch(dateOfBirthAction(`${dateOfBirthYearEl.current.value}-${value}-${dateOfBirthDayEl.current.value}`))
        dispatch(masterNumberDOBAction(`${dateOfBirthDayEl.current.value}${value}${dateOfBirthYearEl.current.value.substring(2)}`))
        validateDateOfBirth()
      }
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const handleDateOfBirthYear = (e) => {
    try {
      const regex = RegExp(/^$|^\d+$/)
      if (regex.test(dateOfBirthYearEl.current.value)) {
        dispatch(
          dateOfBirthAction(`${dateOfBirthYearEl.current.value}-${dateOfBirthMonthEl.current.value}-${dateOfBirthDayEl.current.value}`)
        )
        dispatch(
          masterNumberDOBAction(
            `${dateOfBirthDayEl.current.value}${dateOfBirthMonthEl.current.value}${dateOfBirthYearEl.current.value.substring(2)}`
          )
        )
        validateDateOfBirth()
      }
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurDateOfBirth = () => {
    if (dateOfBirth.length < 3 || dateOfBirth.length > 9) {
      SetIsFocussed(false)
    }
    validateDateOfBirth()
    // dispatch(
    //   masterNumberDOBAction(
    //     `${dateOfBirthDayEl.current.value}${dateOfBirthMonthEl.current.value}${dateOfBirthYearEl.current.value.substring(2)}`
    //   )
    // )
    validateMasterNumber(masterNumber)
  }

  return (
    <div className={styles['fields_margin']}>
      <div
        className={
          dateOfBirthValid === true
            ? dateOfBirth === '' || dateOfBirth === '--'
              ? ''
              : 'form-group has-success'
            : dateOfBirthValid === false
              ? 'form-group has-error'
              : ''
        }
      >
        <label className="control-label" htmlFor="text" style={{ marginBottom: '0px' }}>
          {t('driver_information.date_of_birth')}
        </label>
        <div className={styles['date_for_birth_labels_flex']}>
          <div className={styles['date_for_birth_day']}>
            <label className="control-label" htmlFor="Date" style={{ marginBottom: '0px' }}>
              {t('driver_information.dd')}
            </label>
          </div>
          <div className={styles['date_for_birth_month']}>
            <label className="control-label" htmlFor="Month" style={{ marginBottom: '0px' }}>
              {t('driver_information.mm')}
            </label>
          </div>
          <div className={styles['date_for_birth_year']}>
            <label className="control-label" htmlFor="Year" style={{ marginBottom: '0px' }}>
              {t('driver_information.yyyy')}
            </label>
          </div>
        </div>
        <input
          ref={dateOfBirthDayEl}
          type="text"
          id="Date"
          aria-labelledby="Date of birth day DD"
          className={['form-control', styles['date_for_birth_day']].join(' ')}
          value={dateOfBirth.split('-')[2] || ''}
          onChange={handleDateOfBirthDay}
          onBlur={onBlurDateOfBirth}
          onFocus={() => SetIsFocussed(true)}
          autoComplete="off"
          maxLength="3"
        />
        <input
          ref={dateOfBirthMonthEl}
          type="text"
          id="Month"
          aria-labelledby="Date of birth month MM"
          className={['form-control', styles['date_for_birth_month']].join(' ')}
          value={dateOfBirth.split('-')[1] || ''}
          onChange={handleDateOfBirthMonth}
          autoComplete="off"
          onBlur={onBlurDateOfBirth}
          onFocus={() => SetIsFocussed(true)}
          maxLength="3"
        />
        <input
          ref={dateOfBirthYearEl}
          type="text"
          id="Year"
          aria-labelledby="Date of birth year YYYY"
          className={['form-control', styles['date_for_birth_year']].join(' ')}
          value={dateOfBirth.split('-')[0] || ''}
          onChange={handleDateOfBirthYear}
          autoComplete="off"
          onBlur={onBlurDateOfBirth}
          onFocus={() => SetIsFocussed(true)}
          maxLength="4"
        />
        {dateOfBirthValid === true ? (
          dateOfBirth === '--' || dateOfBirth === '' ? (
            ''
          ) : (
              <i className={['fa fa-check-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
            )
        ) : dateOfBirthValid === false ? (
          <React.Fragment>
            <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
            <div className={isFocussed ? 'help-block-focused' : 'help-block'}>{t(dateOfBirthError)}</div>
          </React.Fragment>
        ) : (
              ''
            )}
      </div>
      <div className="help-field">{t('driver_information.dob_example')}</div>
    </div>
  )
}

export default withTranslation('common')(DateOfBirth)
